import React from 'react';
import styles from './features.module.scss';
import IconCheckCircle from '@dealroadshow/uikit-icon/IconCheckCircle';

const Features = () => (
  <div className={ styles.featuresWrp }>
    <div className={ styles.features }>
      <div className={ styles.featuresTitle }>
        Why 17g5.com?
      </div>

      <ul className={ styles.featuresList }>
        <li className={ styles.feature }>
          <div className={ styles.featureIcon }><IconCheckCircle /></div>
          <div className={ styles.featureText }>
            It’s used by the vast majority of issuers, underwriters & NRSROs
          </div>
        </li>
        <li className={ styles.feature }>
          <div className={ styles.featureIcon }><IconCheckCircle /></div>
          <div className={ styles.featureText }>Simple, transparent pricing with no hidden fees</div>
        </li>
        <li className={ styles.feature }>
          <div className={ styles.featureIcon }><IconCheckCircle /></div>
          <div className={ styles.featureText }>It’s easier to setup & manage</div>
        </li>
        <li className={ styles.feature }>
          <div className={ styles.featureIcon }><IconCheckCircle /></div>
          <div className={ styles.featureText }>
            It’s faster and more intuitive
          </div>
        </li>
        <li className={ styles.feature }>
          <div className={ styles.featureIcon }><IconCheckCircle /></div>
          <div className={ styles.featureText }>It provides guaranteed upfront cost savings</div>
        </li>
        <li className={ styles.feature }>
          <div className={ styles.featureIcon }><IconCheckCircle /></div>
          <div className={ styles.featureText }>It provides fanatical 24x7x365 US-based support</div>
        </li>
      </ul>
    </div>
  </div>
);

export default Features;
